import { Injectable } from '@angular/core';
import { FormBuilder, FormControl, FormGroup } from '@angular/forms';

import { FormControlTemplate } from './form.model';

import reduce from 'lodash-es/reduce';

@Injectable()
export class FormService {
  constructor(private formBuilder: FormBuilder) {}

  public generateFormGroup(
    forms: FormControlTemplate[],
    validators?: any[],
  ): FormGroup {
    const formGroupConfig = this._generateFormGroupConfigs(forms);
    return validators
      ? this.formBuilder.group(formGroupConfig, { validator: validators })
      : this.formBuilder.group(formGroupConfig);
  }

  public generateFormControl(form: any): FormControl {
    const formControlConfig: any = this._generateFormControlConfig(form);
    return new FormControl(...formControlConfig);
  }

  private _generateFormGroupConfigs(forms: any[]): any {
    return reduce(
      forms,
      (result: any, form: any) => {
        if (!form.updateKey) {
          return result;
        }
        if (form.formGroup) {
          return {
            ...result,
            [form.updateKey]: this.generateFormGroup(
              form.formGroup,
              form.validators,
            ),
          };
        }
        return {
          ...result,
          [form.updateKey]: this._generateFormControlConfig(form),
        };
      },
      {},
    );
  }

  private _generateFormControlConfig(form: FormControlTemplate): any {
    const formControlValue: any[] = [
      { value: form.model, disabled: form.disable },
    ];
    return form.validators
      ? [...formControlValue, form.validators]
      : formControlValue;
  }
}
